import { useDuviNicheSiteHome } from "./use-duvi-niche-site-home";
import { DuviNicheSiteHomeView } from "./duvi-niche-site-home-view";

/**
 * DuviNicheSiteHome — the apex landing route. Thin container: calls the
 * behaviour hook and hands its model to the view (hook + view + container
 * split, architecture §6.1).
 */
export function DuviNicheSiteHome() {
  const model = useDuviNicheSiteHome();
  return <DuviNicheSiteHomeView {...model} />;
}
